"use client";

import * as React from "react";

import { cn } from "@acme/ui/lib/utils";
import { X } from "lucide-react";

export interface MadeWithBadgeProps
    extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
    className?: string;
    imgClassName?: string;
    href: string;
    src: string;
    alt: string;
}

export function MadeWithBadge({
    className,
    imgClassName,
    href,
    src,
    alt,
    ...props
}: MadeWithBadgeProps) {
    const [visible, setVisible] = React.useState(true);
    if (!visible) return null;

    return (
        <div className={cn("fixed bottom-4 right-4 z-[9999]")}>
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={alt}
                className={cn(
                    "flex items-center justify-center rounded-full border border-white/20 bg-white/10 backdrop-blur-md shadow-lg ring-1 ring-black/5 p-1 transition-colors hover:bg-white/15",
                    className,
                )}
                {...props}
            >
                <img
                    src={src}
                    alt={alt}
                    className={cn("h-10 w-auto drop-shadow rounded-full", imgClassName)}
                    loading="lazy"
                    decoding="async"
                />
            </a>

            <button
                type="button"
                aria-label="Hide badge"
                title="Hide badge"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setVisible(false);
                }}
                className="absolute -top-1.5 -right-1.5 grid place-items-center size-5 rounded-full bg-black/60 text-white hover:bg-black/70 border border-white/20 shadow-sm"
            >
                <X className="size-3" aria-hidden="true" />
            </button>
        </div>
    );
}